// The blog's posts, newest first. Each post's body is in posts/<slug>.tsx; marketingPages.tsx
// turns every entry here into a prerendered page with its sitemap entry, share card,
// BlogPosting structured data and RSS item. Adding a post: write the body, add it here, run
// `ui-cli og-cards`, and make seo.test.tsx pass.
import AuctionGrades from './posts/AuctionGrades';
import AuctionSheet from './posts/AuctionSheet';
import CostCalculator from './posts/CostCalculator';
import ExportAgent from './posts/ExportAgent';
import KeiTrucks from './posts/KeiTrucks';
import TwentyFiveYearRule from './posts/TwentyFiveYearRule';
export const POSTS = [
    {
        slug: 'jdm-import-cost-calculator',
        title: 'JDM import cost calculator: hammer to landed · Right Hand DMS',
        headline: 'JDM import cost calculator: from hammer price to landed cost',
        description: 'A JDM import cost calculator: what a car from a Japanese auction costs landed, from agent and auction fees to RoRo freight, duty, MPF, HMF, broker and title.',
        keyphrase: 'JDM import cost calculator',
        k: '算',
        topic: 'Import costs',
        published: '2026-10-12',
        modified: '2026-10-12',
        minutes: 6,
        excerpt: 'Put in the hammer price and your agent’s fees and get the landed cost, line by line, plus the sale price your margin needs.',
        Body: CostCalculator
    },
    {
        slug: 'how-to-read-a-japanese-auction-sheet',
        title: 'How to read a Japanese auction sheet · Right Hand DMS',
        headline: 'How to read a Japanese auction sheet',
        description: 'How to read a Japanese auction sheet: where the grades, mileage, era year, options, damage map and inspector notes sit, and what each mark means.',
        keyphrase: 'read Japanese auction sheet',
        k: '査',
        topic: 'Auction sheets',
        published: '2026-10-12',
        modified: '2026-10-12',
        minutes: 8,
        excerpt: 'Where everything is on the sheet, how to turn H13 into 2001, and the damage codes that should change your bid.',
        Body: AuctionSheet
    },
    {
        slug: 'japanese-auction-grades-explained',
        title: 'Japanese auction grades explained, S to R · Right Hand DMS',
        headline: 'Japanese auction grades explained, from S to R',
        description: 'What each Japanese auction grade means, from S and 6 down to 3, RA and R, how the interior and exterior letters work, and which grades to bid on for resale.',
        keyphrase: 'Japanese auction grades',
        k: '評',
        topic: 'Auction grades',
        published: '2026-10-12',
        modified: '2026-10-12',
        minutes: 6,
        excerpt: 'The overall grade, the interior letter and what an R really tells you, with what each one usually means for reconditioning.',
        Body: AuctionGrades
    },
    {
        slug: '25-year-rule-jdm-cars-eligible-2026',
        title: '25-year rule: JDM cars you can import in 2026 · Right Hand DMS',
        headline: 'The 25-year rule: which JDM cars you can import in 2026',
        description: 'How the 25-year import rule works for JDM cars, why the month of manufacture matters, the paperwork that claims it, and the 2001 models that clear in 2026.',
        keyphrase: '25-year rule JDM import',
        k: '規',
        topic: '25-year rule',
        published: '2026-10-12',
        modified: '2026-10-12',
        minutes: 7,
        excerpt: 'Model year 2001 is clearing month by month. How the exemption is counted, what proves it, and the cars worth watching.',
        Body: TwentyFiveYearRule
    },
    {
        slug: 'choosing-a-japanese-export-agent',
        title: 'Choosing a Japanese export agent: a checklist · Right Hand DMS',
        headline: 'Choosing a Japanese export agent: a checklist for import shops',
        description: 'What to compare before you sign with a Japanese export agent: fees, deposits, auction access, sheet speed, photos, damage claims, payment and shipping.',
        keyphrase: 'Japanese export agent',
        k: '代',
        topic: 'Export agents',
        published: '2026-10-12',
        modified: '2026-10-12',
        minutes: 6,
        excerpt: 'Twelve questions to ask an export agent before your first bid, and why many shops keep more than one account.',
        Body: ExportAgent
    },
    {
        slug: 'importing-a-kei-truck',
        title: 'Importing a kei truck from Japan: what to check · Right Hand DMS',
        headline: 'Importing a kei truck from Japan: what to check first',
        description: 'Before you import a kei truck from Japan: the 25-year rule, state road rules, how customs may classify it, 4WD and dump-bed options, and rust on the sheet.',
        keyphrase: 'import kei truck',
        k: '軽',
        topic: 'Kei trucks',
        published: '2026-10-12',
        modified: '2026-10-12',
        minutes: 6,
        excerpt: 'Kei trucks sell fast, but state rules and classification can turn a good buy into a slow one. What to check before you bid.',
        Body: KeiTrucks
    }
];
export const blogPath = (slug)=>`/blog/${slug}`;
